import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

const TYPES = [
	'general',
	'ops-internal'
] as const;

export type JobNoteType = typeof TYPES[number];

export interface IJobNote extends IModel{
	jobKey?: string;
	content?: string;
	type?: JobNoteType;
}

const jobNoteFactory = modelFactory.createFactory<IJobNote>('JobNote', _.assign({}, model, {
	jobKey: {
		setFilters: valueFilters.clean
	},
	content: {
		rules: validator.required()
	}, 
	type: {
		setFilters: valueFilters.clean,
		defaultValue: TYPES[0],
		rules: validator.inList(TYPES)
	}
}));

export default jobNoteFactory;